import { ValidationError } from "yup";

import { ProductFields } from "./util";

export interface ProductSectionsProps {
  fieldHasError: (field: string) => boolean;
  getErrorByField: (field: string) => string | undefined;
  generateBaseFieldProps: (name: ProductFields) => BaseFieldProps;
  viewOnly?: boolean;
  errors?: ValidationError[];
}

export interface BaseFieldProps {
  error: boolean;
  errorMessage: string | undefined;
  "data-cy": string;
  dataCy: string;
  label: string;
  placeholder: string;
  "aria-label": ProductFields;
  disabled: boolean | undefined;
  name: ProductFields;
}

export enum ProductObjects {
  DETAILS = "details",
}
export interface ProductChangeKeys {
  [ProductObjects.DETAILS]: boolean;
}

export type ProductChangeOptions = ProductObjects;
